// REACT_APP_API_URL / REACT_APP_PARTNER_API_URL are build-time env vars each
// deploy target (dev, staging, prod) should set explicitly. They take
// precedence over the NODE_ENV guess below, which only distinguishes local
// dev from everything else and silently sends any non-dev build (staging
// included) to production hosts.
export const base =
  process.env.REACT_APP_API_URL ||
  (process.env.REACT_APP_NODE_ENV === "development"
    ? "https://dev-api.awasource.com"
    : "https://api.awasource.com");

export const partnerBase =
  process.env.REACT_APP_PARTNER_API_URL ||
  (process.env.REACT_APP_NODE_ENV === "development"
    ? "https://dev-partner-api.awasource.com"
    : "https://partner-api.awasource.com");
